import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import noop from 'lodash/noop'
import { globalKeyStore } from '../../redux/actions/globalState'
import ConfirmationPage from './ConfirmationPage'
import PaymentBookingPage from './PaymentBookingPage'
import FormCard from './FormCard'
import CommonBtn from '../../components/global/CommonBtn'
import { EMPTY_OBJECT } from '../../constants/globalConstants'
import moment from 'moment'
// import {
//     // getEventDetails,
//     getFilteredEventList
// } from '../../redux/actions/MainAction'
// import { useLocation } from 'react-router'
import { getPartnerDetails, getPriceBreakdown, isUserLoggedIn } from '../../utils/helper'
import { useForm } from 'react-hook-form'
import Loader from '../../components/global/Loader'
// import { useNavigate } from 'react-router'
// import { useParams } from 'react-router-dom'
import { getConfigDetails } from '../../services/config'

// import BookingAlert from '../../components/global/BookingAlert'

function PassBooking({ dispatch, bookingFormPage, eventData, loader, notify, selectedFacilityId, selectedYearForLabel, sessionDetails, passData, userDetails }) {
    // const partner = window.location.toString().split('/')[3]
    // const navigate = useNavigate()
    // const { facility } = useParams()
    const nextFormStep = () => dispatch(globalKeyStore({ bookingFormPage: bookingFormPage + 1 }))

    const prevFormStep = () => dispatch(globalKeyStore({ bookingFormPage: bookingFormPage - 1 }))

    const { register, handleSubmit, watch, formState: { errors }, control, getValues, reset, setValue } = useForm()

    const fname = watch('name', false)
    const femail = watch('email', false)
    const fphone = watch('phone', false)
    const expiration_date = watch('expiration_date', false)
    const fcard_pan = watch('card_pan', false)
    const fcard_date_expiry_year = watch('card_date_expiry_year', false)
    const fcard_date_expiry_month = watch('card_date_expiry_month', false)
    const fcard_card_security_cvx_2 = watch('card_card_security_cvx_2', false)
    // const { pathname } = useLocation()
    const [sessionObj, setSessionObj] = useState(null)
    const localFacilityId = JSON.parse(localStorage.getItem('selectedFacilityId'))
    const [facilityDet, setFacilityDet] = useState({
        name: null,
        defaultPrice: '0.00'
    })
    // const [parkingPrice, setParkingPrice] = useState(null)
    useEffect(() => {
        if (getPartnerDetails()?.clients?.secret) {
            const passID = JSON.parse(localStorage.getItem('passData'))
            const end_time_local = localStorage.getItem('end_time')
            const today = end_time_local ? moment(new Date(end_time_local))?.format('YYYY-MM-D') : selectedYearForLabel ? moment(new Date(selectedYearForLabel))?.format('YYYY-MM-D') : moment(new Date())?.format('YYYY-MM-D')
            const pathId = localStorage.getItem('booking_event')

            // let partOrRM = partnerData?.partner_details ? partnerData?.slug : partnerData?.partner_slug
            // if (!pathId || (partnerData && (partner?.toLowerCase() !== (partOrRM || '')?.toLowerCase()))) {
            //     if (facility) {
            //         navigate(`/${partner}/${facility}`)
            //     } else {
            //         navigate('/' + partner)
            //     }
            // }
            // dispatch({ type: CONSTANTS.SESSION_EVENT_REQUEST })
            // to filter the date of current month from api:-
            // const currentSelDate = end_time_local ? moment(end_time_local)?.format('MMM-YYYY') : moment(startDate)?.format('MMM-YYYY')

            // to find the id from url 
            // const curUrlPath = pathname?.split('/') // Old functionality
            // const pathId = curUrlPath[curUrlPath.length - 1] // Old functionality
            // facility id 

            const selLocalFacilityId = JSON.parse(localStorage?.getItem('selectedFacilityId'))

            if (selLocalFacilityId || selectedFacilityId) {
                const eventFacilityid = (selLocalFacilityId) ? selLocalFacilityId : selectedFacilityId
                dispatch(globalKeyStore({ selectedFacilityId: eventFacilityid }))

                const sessionPayload = {
                    'is_first_load': 1,
                    'facility_id': eventFacilityid,
                    'rate_id': '',
                    'event_id': '',
                    'client_id': getConfigDetails()?.CLIENT_SECRET
                }
                // getting Selected Event type from local 
                const localSelectedType = localStorage?.getItem('selectEventType')
                dispatch(globalKeyStore({ selectEventType: localSelectedType }))
                // setParkingPrice(localSelectedType == 'event' ? (eventData?.[0]?.event_rate === '0.00' || eventData?.[0]?.event_rate === 0) ? eventData?.[0]?.facilities?.[0]?.base_event_rate : eventData?.[0]?.event_rate : eventData?.[0]?.price)

                // conditional for event / pass
                if (localSelectedType !== 'event') {
                    sessionPayload.rate_id = Number(pathId)
                    if (passID?.id) {
                        sessionPayload.rate_id = Number(passID?.id)
                    }
                    dispatch(globalKeyStore({ selectedPassId: Number(pathId) }))

                    // const eventpayload = { event_type: EVENT_TYPES?.BUNDLE_PASS, facility_id: eventFacilityid, pass_id: pathId, month_date: today }
                    dispatch(globalKeyStore({ startValue: new Date(today) }))
                    // if (eventpayload?.facility_id !== null) {
                    //     dispatch(getFilteredEventList(eventpayload)).then((res) => {
                    //         dispatch(globalKeyStore({ selectedPassId: Number(pathId), passData: res?.data }))
                    //     })
                    // } else {
                    //     // navigate(0)
                    // }

                    localStorage.setItem('bookingFormPage', bookingFormPage)
                } else {
                    sessionPayload.event_id = Number(pathId)
                    if (passID?.id) {
                        sessionPayload.rate_id = Number(passID?.id)
                    }

                    dispatch(globalKeyStore({ selectedEventId: Number(pathId) }))
                    // api for event
                    // const eventpayload = { event_type: EVENT_TYPES?.EVENT, facility_id: eventFacilityid, month_date: today }
                    dispatch(globalKeyStore({ startValue: new Date(today) }))
                    // dispatch(getFilteredEventList(eventpayload)).then((res) => {
                    //     const filterEvents = res?.data?.[currentSelDate] ? res?.data?.[currentSelDate] : []
                    //     const filterData = filterEvents?.filter((item) => item?.id == pathId)
                    //     localStorage.setItem('eventData', JSON.stringify(filterData))
                    //     if (pathId !== 0 && pathId !== undefined && pathId !== null) {
                    //         dispatch(globalKeyStore({ bookingFormPage: 0, eventData: filterData, selectedEventId: Number(pathId) }))
                    //     }
                    // })
                }
                localStorage.setItem('bookingFormPage', bookingFormPage)
                setSessionObj(sessionPayload)

            }
            localStorage.setItem('coupon', '')
            localStorage.setItem('couponApplied', '')
            localStorage.setItem('couponFilled', '')
            localStorage.setItem('promo_applied', '')
            if (eventData?.length > 0 && eventData[0]?.facilities?.length) {
                let facilityName = eventData[0].facilities.filter((item) => item.id === localFacilityId)
                if (facilityName.length > 0) {
                    setFacilityDet({ ...facilityDet, defaultPrice: facilityName[0].base_event_rate, name: facilityName[0].full_name })
                }
            }
        }

    }, [passData])
    useEffect(() => {
        if (isUserLoggedIn()) {
            setTimeout(() => {
                reset(formValues => ({ ...formValues, email: userDetails?.email ? userDetails?.email : '', name: userDetails?.name ? userDetails?.name : '', phone: userDetails?.phone_number ? userDetails?.phone_number : '', }))
            }, 100)
        }
    }, [userDetails])

    return (
        (loader) ? <div className='d-flex align-content-center flex-wrap vh-100 justify-content-center'><Loader /></div> : <div className="container my-5">
            <div className="position-relative m-4 mb-5">
                <div className="progress" role="progressbar" aria-label="Progress" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100" style={{ height: '1px' }}>
                    <div className="progress-bar" style={bookingFormPage === 1 ? { width: '50%' } : { width: '0%' }}></div>
                </div>
                <CommonBtn isProgressBtn className={'position-absolute top-0 start-0 translate-middle btn btn-sm btn-primary rounded-pill'} value={'1'} style={{ width: '2rem', height: '2rem' }} />
                <CommonBtn isProgressBtn className={bookingFormPage == 1 || bookingFormPage == 2 ? 'position-absolute top-0 start-50 translate-middle btn btn-sm btn-primary rounded-pill' : 'position-absolute top-0 start-50 translate-middle btn btn-sm btn-secondary rounded-pill'} value={'2'} style={{ width: '2rem', height: '2rem' }} />
                <CommonBtn isProgressBtn className={bookingFormPage == 2 ? 'position-absolute top-0 start-100 translate-middle btn btn-sm btn-success rounded-pill' : 'position-absolute top-0 start-100 translate-middle btn btn-sm btn-secondary rounded-pill'} value={'3'} style={{ width: '2rem', height: '2rem' }} />

            </div>
            {(sessionDetails?.data?.amount || sessionDetails?.data?.amount == 0) && <div className="bill-card">
                {passData?.price && <div className="row align-items-center fw-bold text-primary">
                    <div className="col text-start">Parking Price{/* Including Tax*/}</div>
                    <div className="col text-end">{`$${Number(passData?.price) > 0 || (Number(passData?.price) === 0) ? Number(passData?.price).toFixed(2) : facilityDet.defaultPrice}`}</div>
                </div>}
                {getPriceBreakdown(sessionDetails)}
                <div className="mt-3 d-flex mb-4 p-3 bg-primary bg-opacity-10 border justify-content-between">
                    <h3 className='fw-bold text-primary'>Total Price -</h3>
                    <h3 className='fw-bold text-secondary'>{`$${sessionDetails?.data?.amount ? Number(sessionDetails?.data?.amount)?.toFixed(2) : '0.00'}`}</h3>
                </div>
            </div>}

            <div>
                <FormCard currentStep={bookingFormPage} prevFormStep={prevFormStep}>
                    {bookingFormPage >= 0 && (<div className={bookingFormPage === 0 ? 'd-block border p-2' : 'd-none'}><PaymentBookingPage
                        notify={notify}
                        reset={reset}
                        register={register}
                        handleSubmit={handleSubmit}
                        control={control}
                        errors={errors}
                        bookingFormPage={bookingFormPage}
                        nextFormStep={nextFormStep}
                        getValues={getValues}
                        sessionObj={sessionObj}
                        setValue={setValue}
                        fname={fname}
                        femail={femail}
                        fphone={fphone}
                        fcard_pan={fcard_pan}
                        fcard_date_expiry_year={fcard_date_expiry_year}
                        fcard_date_expiry_month={fcard_date_expiry_month}
                        fcard_card_security_cvx_2={fcard_card_security_cvx_2}
                        expiration_date={expiration_date}
                    /></div>)}

                    {bookingFormPage >= 1 && (<div className={bookingFormPage === 1 ? 'd-block' : 'd-none'}><ConfirmationPage bookingFormPage={bookingFormPage} nextFormStep={nextFormStep} prevFormStep={prevFormStep} paybaleAmount={eventData?.[0]?.paybaleAmount} notify={notify} /></div>)}
                </FormCard>
            </div>
        </div>
    )
}

PassBooking.propTypes = {
    dispatch: PropTypes.func,
    notify: PropTypes.func,
    selectedEventId: PropTypes.number,
    bookingFormPage: PropTypes.number,
    eventData: PropTypes.object,
    startDate: PropTypes.string,
    loader: PropTypes.bool,
    selectEventType: PropTypes.string,
    sessionDetails: PropTypes.object,
    selectedFacilityId: PropTypes.string,
    selectedYearForLabel: PropTypes.string,
    passData: PropTypes.object,
    bookPass: PropTypes.bool,
    userDetails: PropTypes.object,
}

PassBooking.defaulProps = {
    dispatch: noop,
    notify: noop,
    selectedEventId: 1,
    bookingFormPage: 0,
    eventData: EMPTY_OBJECT,
    startDate: new Date(),
    loader: false,
    selectEventType: '',
    sessionDetails: EMPTY_OBJECT,
    selectedFacilityId: '',
    selectedYearForLabel: '',
    passData: EMPTY_OBJECT,
    bookPass: false,
    userDetails: EMPTY_OBJECT,
}



function mapStateToProps({ globalReducers, mainReducer, loginReducer }) {
    return {
        selectedPassType: globalReducers?.selectedPassType,
        selectedEventId: globalReducers?.selectedEventId,
        bookingFormPage: globalReducers?.bookingFormPage,
        eventData: globalReducers?.eventData,
        startDate: globalReducers?.startValue,
        loader: mainReducer?.loader,
        selectEventType: globalReducers?.selectEventType,
        sessionDetails: globalReducers?.sessionDetails,
        selectedFacilityId: globalReducers?.selectedFacilityId,
        selectedYearForLabel: globalReducers?.selectedYearForLabel,
        userDetails: (Object.keys(globalReducers?.userDetails).length > 0) ? globalReducers?.userDetails : loginReducer?.data?.data?.user,
    }
}

export default connect(mapStateToProps)(PassBooking)